import React, { Fragment } from "react"

import {
  AccordionComponent as Accordion,
  Summary,
  Details,
  Text,
} from "components/ui/Accordion"

const Content = () => {
  return (
    <Fragment>
      <Accordion>
        <Summary>Why is my debt in PlusPlus Capital?</Summary>
        <Details>
          <Text>
            PlusPlus capital buys debt portfolios consisting of regularly unpaid
            invoices from banks, mobile companies and other companies with a
            large base of customers. Companies generally don’t want to
            personally handle clients who don’t pay their debts on time and
            these claims are sold to companies which collect debts. If your
            unpaid obligations have reached PlusPlus Capital then this is the
            way and reason why. PlusPlus Capital is the new legal owner of the
            claim and thus also the new partner to talk to when erasing the
            debt.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>What should I do?</Summary>
        <Details>
          <Text>
            Having seen tens of thousands of similar cases over time, we
            understand why you can’t always meet your financial obligations. For
            this reason, we offer our help to compile a reasonable and
            manageable payment plan to pay off the debt, considering your income
            and other factors. Our professional employees are dedicated to
            resolving the issues quickly and efficiently, therefore please call
            the number on the letter sent to you by PlusPlus Capital or e-mail
            us with reference to the reference number indicated in the letter.
            The faster you agree on resolving the debt, the cheaper and easier
            it is for all parties.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Who should I talk to about my debt?</Summary>
        <Details>
          <Text>
            If PlusPlus Capital has contacted you, this means that your initial
            creditor has not managed to resolve your debt relationship in a
            positive manner during the specified time and they have sold the
            claim. Therefore, PlusPlus Capital is the owner of the claim and the
            communication party for resolving it, and there is no reason to talk
            to the initial creditor about the matter any longer. If you go back
            to your initial creditor, you will be referred back to PlusPlus
            Capital.
          </Text>
        </Details>
      </Accordion>
    </Fragment>
  )
}

export default Content
